import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-repository-movement-form', {
  mixins: [eventListenerMixin],

  properties: {
    repositoryId: {
      type: String,
    },

    batch: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.tree = this.querySelector('tr-tree');
    if (this.batch) {
      this.input = this.querySelector('#tr_repository_batch_movement_parent_gid');
    } else {
      this.input = this.querySelector('#tr_repository_movement_parent_gid');
    }

    if (this.batch) this.setBatch();
    this.listenTo(this, 'click', this.handleClick.bind(this));
  },

  ready() {
    this.toggleCurrentNode();
  },

  setBatch() {
    const toolbar = document.querySelector('tr-repository-folder-table-toolbar');
    if (!toolbar) return;
    this.querySelector('#tr_repository_batch_movement_resource_gids').value = toolbar.selected;
  },

  handleClick(e) {
    const node = closest(e.target, '.repository-tree-node');
    if (!node) return;

    const item = this.tree.querySelector('.tr-tree-item-content.active');
    if (item) item.classList.remove('active');
    closest(node, '.tr-tree-item-content').classList.add('active');
    this.input.value = node.dataset.gid;
  },

  toggleCurrentNode() {
    const link = this.tree.querySelector(
      `#selectable-node-tr_repository_repository_${this.repositoryId}`,
    );
    setTimeout(() => {
      if (link) closest(link, '.tr-tree-item').toggleExpanded();
    }, 0);
  },

  disconnected() {
    this.stopListening();
  },
});
